import React from "react";
import "./style.scss";
import { Link } from "./link";
import { useStaticQuery, graphql } from "gatsby";

export const query = graphql`
  query {
    api {
      configFooterIconBar {
        id
        item {
          id
          label {
            id
            text_sq
            text_en
          }
          uri
          icon
        }
      }
    }
  }
`;

const QuickLinks = () => {
  const apiData = useStaticQuery(query);
  const data = apiData.api.configFooterIconBar.item;

  return (
    <ul className="quick-links">
      {data.map((item, i) => (
        <Link key={i} text={item.label} icon={item.icon} route={item.uri} />
      ))}
    </ul>
  );
};

export default QuickLinks;
